/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AssignDelegateRequest } from '../models/assign-delegate-request';
import { CreateDelegateRequest } from '../models/create-delegate-request';
import { DelegateResponse } from '../models/delegate-response';
import { GenericResponse } from '../models/generic-response';
import { UpdateDelegateRequest } from '../models/update-delegate-request';

/**
 * delegate apis
 */
@Injectable({ providedIn: 'root' })
export class DelegateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createDelegate()` */
  static readonly CreateDelegatePath = '/api/v1/delegations';

  /**
   * create new delegate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDelegate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  createDelegate$Response(
    params: {
      body: CreateDelegateRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DelegateResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DelegateService.CreateDelegatePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DelegateResponse>;
        })
      );
  }

  /**
   * create new delegate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDelegate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  createDelegate(
    params: {
      body: CreateDelegateRequest;
    },
    context?: HttpContext
  ): Observable<DelegateResponse> {
    return this.createDelegate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DelegateResponse>): DelegateResponse => r.body)
    );
  }

  /** Path part for operation `deleteDelegateById()` */
  static readonly DeleteDelegateByIdPath = '/api/v1/delegations/{id}';

  /**
   * delete delegate by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDelegateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDelegateById$Response(
    params: {
      /**
       * The stage id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DelegateService.DeleteDelegateByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * delete delegate by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteDelegateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDelegateById(
    params: {
      /**
       * The stage id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteDelegateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateDelegateStatusById()` */
  static readonly UpdateDelegateStatusByIdPath = '/api/v1/delegations/{id}';

  /**
   * update delegate status by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDelegateStatusById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDelegateStatusById$Response(
    params: {
      /**
       * The delegate id that needs to change DelegateStatus
       */
      id: number;
      body: UpdateDelegateRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DelegateResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DelegateService.UpdateDelegateStatusByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<DelegateResponse>;
        })
      );
  }

  /**
   * update delegate status by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDelegateStatusById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDelegateStatusById(
    params: {
      /**
       * The delegate id that needs to change DelegateStatus
       */
      id: number;
      body: UpdateDelegateRequest;
    },
    context?: HttpContext
  ): Observable<DelegateResponse> {
    return this.updateDelegateStatusById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DelegateResponse>): DelegateResponse => r.body)
    );
  }

  /** Path part for operation `assignDelegate()` */
  static readonly AssignDelegatePath = '/api/v1/delegations/users/assign';

  /**
   * assign delegate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignDelegate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignDelegate$Response(
    params: {
      body: AssignDelegateRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DelegateService.AssignDelegatePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * assign delegate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignDelegate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignDelegate(
    params: {
      body: AssignDelegateRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.assignDelegate$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
